import { FieldDefinition } from "./fieldDefinitions";

export interface PatientSurgeryDto {
  surgeryId: number;
  patientId: number;
  surgeryTypeId: number;
  surgeryDate: string;
  startTime?: string | null;
  endTime?: string | null;
  remarks?: string | null;
  active: boolean;
  statusDescr: string;
  category?: string | null;
  doctorId?: number | null;
  anesthesiologistId?: number | null;
  preOpDiagnosis?: string | null;
  postOpDiagnosis?: string | null;
}

export interface SurgeryTypeOption {
  surgeryTypeId: number;
  idDescr: string;
}

export const getSurgeryTypeOptions = (
  surgeryTypes: Array<SurgeryTypeOption> = [],
) =>
  surgeryTypes.map((st) => ({
    label: st.idDescr ?? "Χωρίς περιγραφή",
    value: st.surgeryTypeId,
  }));

export const patientSurgeryKeyId = "surgeryId" as const;

export const patientSurgeryFormData: string[] = [
  "surgeryDate",
  "startTime",
  "endTime",
  "remarks",
  "active",
  "surgeryTypeCode",
  "surgeryTypeDescr",
  "category",
  "doctorId",
  "anesthesiologistId",
  "statusDescr",
  "preOpDiagnosis",
  "postOpDiagnosis",
];

export const getPatientSurgeryFields = (
  options: Array<{ value: string | number; label: string }> = [],
): FieldDefinition[] => [
  {
    name: "surgeryTypeId",
    label: "Περιγραφή Επέμβασης",
    type: "select",
    required: true,
    options,
  },
  { name: "category", label: "Κατηγορία", type: "text", required: false },
  {
    name: "surgeryDate",
    label: "Ημερομηνία Χειρουργείου",
    type: "date",
    required: true,
  },
  { name: "startTime", label: "Ώρα Έναρξης", type: "time", required: false },
  { name: "endTime", label: "Ώρα Λήξης", type: "time", required: false },
  { name: "statusDescr", label: "Κατάσταση", type: "text", required: true },
  {
    name: "preOpDiagnosis",
    label: "Προεγχειρητική Διάγνωση",
    type: "text",
    required: false,
  },
  {
    name: "postOpDiagnosis",
    label: "Μετεγχειρητική Διάγνωση",
    type: "text",
    required: false,
  },
  { name: "remarks", label: "Παρατηρήσεις", type: "text", required: false },
];

export const patientSurgeryFields = getPatientSurgeryFields();

export const patientSurgeryFilters = patientSurgeryFields.filter((f) =>
  ["surgeryTypeId", "surgeryDate", "statusDescr"].includes(f.name),
);

export interface PatientSurgeryDropDownDto {
  surgeryId: number;
  surgeryTypeDescr: string;
  surgeryDate: string;
}
